import CryptoJS from "crypto-js/core";
import AES from "crypto-js/aes";
import MD5 from "crypto-js/md5";

export const AESKey = {
    default: "123!MDLand->20i7~",
    log: "MDLand_log",
};

export const AESTool = {
    encrypt(text: string, key: string) {
        let encryptKey = key || AESKey.default;
        return AES.encrypt(text, encryptKey).toString()
    },
    decrypt(text: string, key: string) {
        let encryptKey = key || AESKey.default;
        let bytes = AES.decrypt(text, encryptKey);
        return bytes.toString(CryptoJS.enc.Utf8)
    },
};

export const MD5Tool = {
    encrypt(text: string) {
        return MD5(text).toString()
    },
};
